import { produce } from 'immer';

import { queryClient } from '../../shared/providers/react-query-provider';
import { getDossierQueryKey } from '../dossier/queries';
import { DossierId, SerializedDossier } from '../dossier/types';

import { getInTripReviewsQueryKey } from './hooks';
import { NormalizedInTripReview } from './types';

export const removeInTripReviewFromCache = (dossierId: DossierId) => {
    queryClient.setQueryData<NormalizedInTripReview>(getInTripReviewsQueryKey(), (cur) => {
        return produce(cur, (draft) => {
            if (!draft) return;
            delete draft[dossierId];
        });
    });

    queryClient.setQueryData<SerializedDossier>(getDossierQueryKey(dossierId), (cur) => {
        return produce(cur, (draft) => {
            if (!draft?.inTripReview) return;
            delete draft.inTripReview[dossierId];
        });
    });
};
